<template>
  <div class="container" v-show="!pageLoading">
    <div class="background_img" v-show="!pageLoading">
      <img v-if="loginPageInfo.bg_img" :src="loginPageInfo.bg_img" alt="" style="width: 100%" />
      <img v-else src="@/assets/images/backgroundImg.png" alt="" />
    </div>
    <div class="login_position" v-show="!pageLoading">
      <div class="login_box">
        <div class="login_logo">
          <img v-if="loginPageInfo.logo" :src="loginPageInfo.logo" alt="" />
          <div class="web_title">资源租赁管理系统</div>
        </div>
        <div class="loginFunc_tab">
          <div class="loginFunc">
            <div id="lbAppText">账号登录</div>
          </div>
          <!-- 二维码 -->
          <div class="appLoginTab" v-if="!status.loginFuncStatus">
            <i class="ico-login-switch-tips"></i>
            <div id="appCodeBox">
              <img id="appCode" src="@/assets/images/getUrlQrcode.jpg" />
            </div>
            <div class="u-scan-tips">微信扫码登录</div>
          </div>
          <!-- 用户密码 -->
          <div class="normalLoginTab loginForm" v-if="status.loginFuncStatus">
            <i class="ico-login-switch-tips"></i>
            <div class="loginUrs">
              <el-form ref="ruleFormRef" :model="formData" :rules="rules">
                <div class="urs">
                  <el-form-item prop="urs">
                    <el-input v-model="formData.urs" class="ursval_input" placeholder="请输入账号" @keydown.enter="loginSubmit(ruleFormRef)" />
                  </el-form-item>
                  <div class="ursicon">
                    <img src="@/assets/images/ico-user.png" alt="" />
                  </div>
                </div>
                <div class="passwords">
                  <el-form-item prop="password">
                    <el-input v-model="formData.password" :type="status.eyeSwitchStatus ? 'password' : ''" class="ursval_input" placeholder="请输入密码" @keydown.enter="loginSubmit(ruleFormRef)" />
                  </el-form-item>
                  <div class="ursicon">
                    <img src="@/assets/images/ico-password.png" alt="" />
                  </div>
                  <div class="eyeicon" @click="eyeSwitch">
                    <img src="@/assets/images/ico-eye-off.png" v-show="status.eyeSwitchStatus" />
                    <img src="@/assets/images/ico-eye.png" v-show="!status.eyeSwitchStatus" />
                  </div>
                </div>
                <div class="passwords" style="display: flex" v-if="loginPageInfo.captcha == '1'">
                  <div class="verification_input_box">
                    <el-form-item prop="vcode">
                      <el-input v-model="formData.vcode" class="verification_input" placeholder="请输入验证码" />
                    </el-form-item>
                  </div>
                  <div class="verification_img" @click="verificationSrcObj()">
                    <img :src="verificationSrc" alt="" v-if="verificationSrcStatus" />
                    <span class="verification_tips">看不清?点击图片换一张</span>
                  </div>
                </div>
              </el-form>
              <!-- 提示 -->
              <div class="m-nerror" id="nerror" v-show="status.nerror">
                <div class="ferrortail"></div>
                <div class="ferrorhead"></div>
              </div>
              <div class="record">
                <el-checkbox v-model="status.remember">记住账号</el-checkbox>
                <el-checkbox v-model="status.isDomain" v-if="loginPageInfo.ldap == '1'">域登录</el-checkbox>
              </div>
              <div class="nerror_text" v-show="nerrorTextStatus">{{ nerrorText }}</div>
              <div class="login_btn" @click="loginSubmit(ruleFormRef)">登录</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filings_number">
      <a target="_blank" href="http://beian.miit.gov.cn"
        >{{ loginPageInfo.icp }}
        <p>{{ loginPageInfo.copyright }}</p>
      </a>
    </div>
    <el-dialog title="安全验证" v-model="otpDialogVisible" :width="500" :show-close="false" :close-on-click-modal="false">
      <template #default>
        <el-form ref="otpFormRef" :model="otpFormData" :rules="otpRules" label-width="60px" @submit.prevent>
          <div class="login_tips">
            <p>为保护账号安全，已启用多因子认证。</p>
            <p
              >系统需短信验证手机<span class="phone_num">{{ optPhoneMask }}</span></p
            >
          </div>
          <el-form-item prop="sms_code">
            <el-input v-model.trim="otpFormData.sms_code" class="otp_input" placeholder="请输入短信验证码" @keyup.enter="otpSubmit" clearable />
            <el-button class="otp_btn" type="primary" @click="getOtpCode" :disabled="otpCountDownTime > 0">{{ otpCountDownTime <= 0 ? '发送短信验证码' : `${otpCountDownTime}s后可重发` }}</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template #footer>
        <el-button plain @click="otpCancel">取消登录</el-button>
        <el-button type="primary" @click="otpSubmit" :disabled="disabledLogin">确认登录</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { onMounted, computed, reactive, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '@/api/index'
onMounted(() => {
  if (window.localStorage.getItem('loginInfo')) {
    let loginInfo = JSON.parse(window.localStorage.getItem('loginInfo'))
    if (loginInfo) {
      formData.urs = loginInfo.urs
      formData.password = loginInfo.password
    }
  }
  getLoginPage()
  verificationSrcObj()
  // 重新登录不能确定是否切换了用户，所以需要清空一下tabsList
  window.sessionStorage.removeItem('tabsList')
})
let status = reactive({
  loginFuncStatus: true,
  remember: true,
  isDomain: true,
  eyeSwitchStatus: true,
  nerror: false,
})
let nerrorText = ref(null)
let nerrorTextStatus = ref(false)
let eyeSwitchImg = ref('')
let formData = reactive({
  urs: '',
  password: '',
  vcode: '',
})
let verificationSrc = ref(api.API + '/vcode/verify.php' + '?getTime=' + new Date().getTime())
let verificationSrcStatus = ref(true)
function verificationSrcObj() {
  verificationSrcStatus.value = false
  window.setTimeout(function () {
    verificationSrcStatus.value = true
  }, 100)
}
let ursVerify = (rule, value, callback) => {
  if (status.nerror) {
    callback(new Error(''))
  } else {
    callback()
  }
}
let passwordVerify = (rule, value, callback) => {
  if (status.nerror) {
    callback(new Error(''))
  } else {
    callback()
  }
}
let verificationVerify = (rule, value, callback) => {
  if (status.nerror) {
    callback(new Error(''))
  } else {
    callback()
  }
}

const rules = reactive({
  urs: [
    { required: true, message: '账号不能为空！', trigger: 'blur' },
    { required: true, validator: ursVerify, trigger: 'blur' },
  ],
  password: [
    { required: true, message: '密码不能为空！', trigger: 'blur' },
    { required: true, validator: passwordVerify, trigger: 'blur' },
  ],
  vcode: [
    { required: true, message: '验证码不能为空！', trigger: 'blur' },
    { required: true, validator: verificationVerify, trigger: 'blur' },
  ],
})

const ruleFormRef = ref(null)
// 账号登录
const lbAppShow = () => {
  status.loginFuncStatus = true
}
// 扫码登录
const lbNormalShow = () => {
  status.loginFuncStatus = false
}
// 查看密码
const eyeSwitch = () => {
  status.eyeSwitchStatus = !status.eyeSwitchStatus
}

let loginPageInfo = ref('')
const pageLoading = ref(true)
const getLoginPage = async () => {
  let res = await api.getLoginPage()
  // console.log("首页信息", res.data);
  if (res.data.code == '0') {
    let info = res.data.data
    loginPageInfo.value = info
    if (~~info.ldp_enable === 1) {
      window.location.replace(info.ldp_reidrect_uri)
      return
    }
    document.title = info.title ? info.title : '资管云'
  }
  pageLoading.value = false
}

// 提交登录
const loginSubmit = async (formEl) => {
  if (disabledLogin.value) return
  nerrorTextStatus.value = false
  status.nerror = false
  await formEl.validate((valid, fields) => {
    if (valid) {
      // 记住密码
      let loginInfo = ''
      if (status.remember) {
        loginInfo = JSON.stringify(formData)
      }
      window.localStorage.setItem('loginInfo', loginInfo)
      accountLogin()
    }
  })
}

const temp_token = ref('')
const otpPhone = ref('')
const optPhoneMask = computed(() => {
  if (otpPhone.value) {
    return otpPhone.value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
  } else {
    return ''
  }
})
const otpCountDownTime = ref(0)
let hrefUrl = '/adminfront/index/#/'
// 管理员
const accountLogin = async () => {
  let isDomainData = ''
  if (loginPageInfo.value.ldap == '1') {
    isDomainData = status.isDomain ? '1' : '0'
  }
  disabledLogin.value = true
  let res = await api.postAccountLogin({
    user_name: formData.urs,
    user_pwd: rsa_encode(formData.password),
    vcode: formData.vcode ?? '',
    is_domain: isDomainData,
    pwd_type: 'rsa',
  })
  disabledLogin.value = false
  // console.log("登录信息", res.data);
  let resData = res.data
  if (resData.code == '0') {
    if (String(loginPageInfo.value.captcha) === '3') {
      // 二次验证
      temp_token.value = resData.data?.temp_token
      otpPhone.value = resData.data?.sms_mobile || ''
      otpCountDownTime.value = resData.data?.remain_seconds || 0
      showOtpDialog()
      otpCountDownTime.value > 0 && countDown()
      return
    }
    loginSuccess(resData.data)
  } else {
    status.nerror = true
    nerrorText.value = `[${res.data.code}]${res.data.message}`
    nerrorTextStatus.value = true
    ruleFormRef._value.validate((valid, fields) => {})
    verificationSrcObj()
  }
}
const getOtpLoading = ref(false)
const getOtpCode = async () => {
  if (otpCountDownTime.value > 0 || getOtpLoading.value) {
    ElMessage.warning('请稍后再发送')
    return
  }
  getOtpLoading.value = true
  const { data: res } = await api.postSmsVerify({
    temp_token: temp_token.value,
  })
  getOtpLoading.value = false
  if (String(res.code) == '0') {
    ElMessage.success('短信验证码发送成功')
    otpCountDownTime.value = 120 // 倒计时二十秒
    countDown()
  } else {
    ElMessage.error(res.message || '系统错误')
  }
}
let timer = null
const countDown = () => {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
  timer = setInterval(() => {
    otpCountDownTime.value--
    if (otpCountDownTime.value <= 0) {
      clearInterval(timer)
      timer = null
    }
  }, 1000)
}

const otpFormRef = ref(null)
const otpFormData = reactive({
  sms_code: '',
})
const otpRules = reactive({
  sms_code: { required: true, message: '验证码不能为空', trigger: 'blur' },
})

const otpDialogVisible = ref(false)
const showOtpDialog = () => {
  otpDialogVisible.value = true
}

const otpCancel = () => {
  otpDialogVisible.value = false
  otpFormRef.value.resetFields()
}

const disabledLogin = ref(false)
const otpSubmit = async () => {
  otpFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      disabledLogin.value = true
      const { data: res } = await api.accountLogin2({
        temp_token: temp_token.value,
        sms_code: otpFormData.sms_code,
      })
      disabledLogin.value = false
      if (String(res.code) == '0') {
        loginSuccess(res.data)
      } else {
        ElMessage.error(res.message || '系统错误')
      }
    }
  })
}

const loginSuccess = (data) => {
  if (data) {
    window.localStorage.setItem('accessToken', data.access_token)
    if (data.index_page) {
      hrefUrl = data.index_page
    }
    if (data.force_show) {
      ElMessage.success('登录成功')
      ElMessageBox.alert(data.force_show, '提示', {
        confirmButtonText: '好的',
        callback: () => {
          window.location.href = hrefUrl
        },
      })
    } else {
      ElMessage.success('登录成功')
      goIndex()
    }
  } else {
    ElMessage.success('登录成功')
    goIndex()
  }
}

const goIndex = () => {
  setTimeout(() => {
    window.location.href = hrefUrl
  }, 500)
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.login_logo {
  display: flex;
  align-items: center;
  .web_title {
    margin-left: 10px;
    font-size: 24px;
    display: none;
  }
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000;
}
/deep/ .el-input__inner {
  -webkit-box-shadow: inset 0 0 0 1000px #fff !important;
  color: #333;
}
.login_tips {
  margin-left: 60px;
  margin-bottom: 10px;
  .phone_num {
    color: var(--el-color-danger);
    margin-left: 4px;
  }
}
.otp_input {
  width: 200px;
}
.otp_btn {
  margin-left: 10px;
  width: 130px;
}
</style>
